// ABOUTME: The Suspense fallback shown while a lazy route chunk loads.
// ABOUTME: Stays blank for a moment so a fast load does not flash a loader.

import { styled } from '@ds/coolshop';
import { useEffect, useState } from 'react';

import { LinearLoader } from '../shared/LinearLoader';

const classes = {
    loading: `loading`,
};

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.loading}`]: {
        padding: theme.spacing(1),
    },
}));

export function DelayedFallback(): JSX.Element | null {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timeout = setTimeout(() => setShow(true), 150);
        return () => clearTimeout(timeout);
    }, []);

    if (!show) {
        return null;
    }
    return (
        <Root className={classes.loading}>
            <LinearLoader />
        </Root>
    );
}
